import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from '../../Transcript/TranscriptStyles';
import { formattedStartAndEndDate, formattedDate } from '../../Transcript/TranscriptUtils';

const TranscriptFooter = ({ minDate, maxDate }) => (
   
     <View style={styles.footer}>
      {/* Disclaimer */}
      {/* <Text style={[styles.footerText, { textAlign: 'left', width: '100%',marginBottom: 0 }]}>
        ‡Disclaimer: This transcript has captured completed training since the launch of the Caregiver Learning Center on {formattedStartAndEndDate(minDate)}  to {formattedStartAndEndDate(maxDate)}, along with On-The-Job credits granted per WAC 388-71-0992. Training taken before the launch of the Caregiver Learning Center can be requested and produced in a separate transcript file from SEIU 775 Benefits Group.
      </Text> */}
   <Text style={styles.leftText}>   </Text>
      {/* Legend Rows */}
      <View style={styles.legendRow}>
         
        <Text style={styles.legendLeftText}>*Legend</Text>
        <Text style={styles.rightText}>Training Program Number: 0001</Text>
      </View>
      <View style={styles.legendRow}>
        <Text style={styles.leftText}>O&S: Orientation & Safety</Text>
        <Text style={styles.rightText}>Training Program Name: Training Partnership</Text>
      </View>
  
      <View style={styles.footerFourColumn}>
    {/* Column 1 */}
            <View style={styles.footerColumn}>
                <Text style={styles.footerText1}>BT: Basic Training 9, 16, 30 </Text>
                {/* <Text style={styles.footerText1}>BT9: Basic Training 9</Text>
         <Text style={styles.footerText1}>BT30: Basic Training 30</Text> */}
                <Text style={styles.footerText1}>CE: Continuing Education</Text>
                <Text style={styles.footerText1}>AHCAS: Advanced Home Care Aide Specialist Program</Text>
                <Text style={styles.footerText1}>CE-CLL: Continuing Education Caregiver Library</Text>
            </View>

            {/* Column 2 */}
            <View style={styles.footerColumn}>
                <Text style={styles.footerText1}>BT70: Basic Training 70</Text>
                <Text style={styles.footerText1}>BT70-ECB: Basic Training 70          Exempt Certification Benefit</Text>
                <Text style={styles.footerText1}>BT7: Basic Training 7</Text>

            </View>
  
    {/* Column 3 */}
   <View style={styles.footerColumn1}>
   
    <Image
      style={styles.signatureImage}
      src="/MerissaSig.png" 
    />
  
    
    <Text style={styles.footerText2}>MERISSA CLYDE</Text>
    <Text style={styles.footerText2}>CHIEF EXECUTIVE OFFICER</Text>
  </View>
  
  
    {/* Column 4 */}
    <View style={styles.footerColumn1}>
      <Image
      style={styles.signatureImage}
      src="/Adamsig.png" 
    />
      <Text style={styles.footerText2}>ADAM GLICKMAN</Text>
      <Text style={styles.companyText}>CHAIR BOARD OF TRUSTEES</Text>
    </View>
  </View>
  
   <View style={styles.legendRow1}>
      <View style={styles.leftWrapper}>
  
        <Text style={styles.leftText1}>THE SEIU 775 BENEFITS GROUP INCLUDES THE SEIU NW TRAINING PARTNERSHIP A NONPROFIT 501(c)(3) SCHOOL FOR CAREGIVERS.</Text>
         </View>
    <View style={[styles.rightWrapper, { alignSelf: 'flex-end' }]}>
  
        <Text style={[styles.leftText1,{ alignSelf: 'flex-end' }]}>Printed Date: {formattedDate}</Text>
        </View>
  
      </View>
      
  
      {/* Page Number */}
      <Text
        style={[styles.footerText, { marginTop: 4, alignSelf: 'flex-end' }]}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        fixed
      />
    </View>
);

export default TranscriptFooter;
